import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { ErrorState } from "@/components/shared/error-state";
import { SkillCard } from "@/components/skills/SkillCard";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useMySkills } from "@/hooks/use-my-skills";

export function MySkillsGrid() {
  const { data: skills, isLoading, isError, refetch } = useMySkills();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-fg-link">
            Contribute
          </div>
          <h1 className="mt-1 font-display text-[30px] font-bold text-fg-1">My Skills</h1>
          <p className="mt-2 max-w-2xl text-fg-2">Skills you authored or own.</p>
        </div>
        <Button asChild>
          <Link to="/submit">
            <Plus className="size-4" />
            Submit a skill
          </Link>
        </Button>
      </div>

      {isLoading ? (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-44 rounded-lg" />
          ))}
        </div>
      ) : null}

      {isError ? <ErrorState onRetry={() => void refetch()} /> : null}

      {!isLoading && !isError && skills && skills.length === 0 ? (
        <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border-2 bg-white py-16 text-center">
          <p className="text-sm font-medium text-fg-2">You haven't submitted any skills yet.</p>
          <Button asChild variant="outline">
            <Link to="/submit">
              <Plus className="size-4" />
              Submit your first skill
            </Link>
          </Button>
        </div>
      ) : null}

      {!isLoading && !isError && skills && skills.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {skills.map((s) => (
            <div key={s.id} className="relative">
              {!s.published ? (
                <span className="absolute right-3 top-3 z-10 rounded-full bg-bg-3 px-2 py-0.5 text-[10px] font-semibold uppercase text-fg-3">
                  Unpublished
                </span>
              ) : null}
              <SkillCard skill={s} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
